import { useEffect, useState } from 'react'

import { PaymentMethod } from '@/enums/payments'
import { isApplePayAvailable } from '@/utils/paymentScreenUtils'

import { useStripeWalletsAvaible } from './useStripeWalletsAvailable'

export const useApplePayAvaiable = (overwriteAllowed: boolean = true, maxDelay?: number) => {
  const [appleAvailable, setAppleAvailable] = useState<boolean | null>(null)

  useEffect(() => {
    setAppleAvailable(isApplePayAvailable())
  }, [setAppleAvailable])

  const [, walletsAvaiable] = useStripeWalletsAvaible(overwriteAllowed, maxDelay)

  const hasCard: boolean | null =
    walletsAvaiable == null ? null : !!walletsAvaiable[PaymentMethod.APPLE_PAY]

  return { appleAvailable, hasCard }
}
